import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import ActionModal from 'components/NavRightClickMenu/components/ActionModal/ActionModal'
import { useFolder } from 'hooks/queries/folders/useFolder'

import { ConfigureMoveFileAutomationModalProps } from './Types'

const errorMessage = (status: number) => {
  if (status === 404) {
    return 'The configured folder might have been deleted and cannot be found. Choose another folder.'
  }

  if (status === 403) {
    return "You don't have access to the configured folder. Request access to an editor or choose another folder."
  }

  return 'An error occurred'
}

const ConfigureMoveFileAutomationModal = (props: ConfigureMoveFileAutomationModalProps) => {
  const handleError = (error: Error) => {
    showToastMessage(errorMessage(parseInt(error.message)), 'error', undefined, 5)
  }
  const initialFolderKey = props.destination_folder_key || props.workflowFolderKey

  const initialFolderQuery = useFolder(initialFolderKey, { onError: handleError, enabled: Boolean(initialFolderKey) })
  const workflowFolderQuery = useFolder(props.workflowFolderKey)

  if (initialFolderQuery.isLoading || workflowFolderQuery.isLoading) {
    return null
  }

  return (
    <ActionModal
      titleText="Pick a location"
      visible
      setVisible={(visible) => {
        if (!visible) {
          props.onCancel?.()
        }
      }}
      selectedFiles={[]}
      disableRoot
      submit={({ selectedFolder }) => {
        props.onConfirm({ destination_folder_key: selectedFolder?.id })
      }}
      ctaText="Select Location"
      isMove
      hidePopover
      skipConfirmation
      currentFolder={workflowFolderQuery.data?.folder}
      initialFolder={initialFolderQuery.data?.folder}
      useAlmanacUI
    />
  )
}

export { ConfigureMoveFileAutomationModal }
